<template>
  <permission-guard situation="site_domain_configuration">
    <v-form ref="domainFrom">
      <v-row>
        <v-col cols="8">
          <v-text-field
            v-model="site.originalDomain"
            class="mb-4"
            label="サイトドメイン"
            style="width: 300px"
            required
          />
          <!-- サブディレクトリ機能復活までコメントアウト -->
          <v-text-field
            ref="root_path"
            v-model="site.rootPath"
            :rules="[rootPathValidation]"
            class="mb-4"
            label="ルートパス"
            style="width: 300px"
            required
          />
          <v-card outlined>
            <v-card-subtitle>
              <span>ロボットアクセス防止設定（reCAPTCHA）</span><br />
              <span class="caption"
                >※独自ドメインを使用する場合は必ず設定して下さい。</span
              >
            </v-card-subtitle>
            <v-card-text>
              <v-text-field
                v-model="site.recaptchaSiteKey"
                class="mb-4"
                label="reCAPTCHA サイトキー"
                required
              />
              <v-text-field
                v-model="site.recaptchaSecretKey"
                class="mb-4"
                label="reCAPTCHA シークレットキー"
                type="password"
                autocomplete="new-password"
                required
              />
            </v-card-text>
          </v-card>

          <v-alert
            color="warning"
            border="left"
            elevation="2"
            class="pl-5 mt-5"
            colored-border
          >
            <h4 class="mb-2">reCAPTCHAについて</h4>
            <p class="caption">
              ・reCAPTCHAは、Googleによるロボットアクセスの防止システムです（利用・登録無料）<br />
              ・お問い合わせフォームへの不正な投稿を防止するために、本システムではreCAPTCHAを採用しています。<br />
              ・独自ドメインを使用する場合は、<a
                href="https://www.google.com/recaptcha/admin/create"
                >こちら</a
              >に従って、必ず利用者にてドメインおよびreCAPTCHA
              v3の利用登録を行ってください。（googleアカウントが必要となります）<br />
              ・登録完了後、reCAPTCHA管理画面よりサイトキーとシークレットキーを設定してください。（暗号化して保存されます）
            </p>
          </v-alert>
        </v-col>
      </v-row>
    </v-form>
    <v-spacer />
    <v-alert dense outlined class="mt-5" type="error" style="width: 400px">
      <span class="caption">
        必ずドメインの設定にミスがないか確認してください。
      </span>
    </v-alert>
    <v-btn color="green darken-1" tile dark depressed @click="update">
      更新
    </v-btn>
  </permission-guard>
</template>

<script>
import axios from 'axios'
import PermissionGuard from '@/components/commons/PermissionGuard'

export default {
  components: { PermissionGuard },
  props: {
    siteId: {
      type: Number,
      required: true
    }
  },
  data: () => {
    return {
      site: {},
      rootPathValidation: (value) => {
        if (!value) {
          return true
        }
        const res = value.match(/^([a-z]|[0-9])+$/g)
        if (res == null) {
          return '半角英数字（小文字）のみ使用できます'
        } else {
          return true
        }
      }
    }
  },
  mounted: function () {
    axios.get(`/api/sites/${this.siteId}/domain/edit`).then(
      ({ data }) => {
        this.site = data.data.attributes
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: error.response.data.errors.toString()
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
  },
  methods: {
    update () {
      const site = this.site
      if (!this.$refs.domainFrom.validate()) {
        return false
      }
      const query = {
        site: {
          originalDomain: site.originalDomain,
          recaptchaSiteKey: site.recaptchaSiteKey,
          recaptchaSecretKey: site.recaptchaSecretKey,
          rootPath: site.rootPath
        }
      }
      axios.patch(`/api/sites/${site.id}/domain`, query).then(
        () => {
          const payload = {
            status: 200,
            message: '変更を保存しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>

<style scoped></style>
